
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { ErrorBase } from 'base-models';
import { ErrorcontrolService } from 'basecomponents';


@Component({
  selector: 'frms-list-filter',
  templateUrl: './list-filter.component.html',
  styleUrls: ['./list-filter.component.scss']
})
export class ListFilterComponent implements OnInit, OnDestroy, AfterViewInit {

  searchForm: FormGroup;
  @Input() myplaceholder: string = "Placeholder";

  private _mylist: any[] = [0];
  @Input()
  public get mylist(): any[] {
    return this._mylist;
  }
  public set mylist(value: any[]) {
    this.configureList(value);
  }
  @Input() includeall: boolean = true;
  /**
   * in order to know the id of all, 
   */
  @Input() includeall_id: string = "-1";
  @Input() includeall_text: string = "All";
  includeAllItem: any = null;

  @Input() selectAllCheked: boolean = false;
  @Input() selectfirst: boolean = false;
  @Input() fieldId: any = "id";
  @Output() onFilterChange: EventEmitter<any> = new EventEmitter();
  /**
   * return a list of selected items.
   */
  @Output() onItemSelected: EventEmitter<any[]> = new EventEmitter();
  @ViewChild('filterby', { static: false }) filterby: MatSelect;
  @ViewChild('allSelected') private allSelected: MatOption;

  constructor(private fb: FormBuilder
  ) {

  }
  ngOnInit() {
    this.searchForm = this.fb.group({
      filterbyformcontrol: new FormControl('')
    });
    
  }
  ngAfterViewInit(){
    if (this.selectAllCheked){
      this.allSelected.select();
      this.getFilterValuesDescription(this.filterby.value);
    }
    
  }

  ngOnDestroy() {

  }
  getValue(item) {
    return item;
    //return item[this.fieldId];
  }

  selectAll($event) {
    console.log("selectAll ", $event);
  }

  toggleItem() {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
    } else if (this.searchForm.controls.filterbyformcontrol.value.length == this.mylist.length) {
      this.allSelected.select();

    }
    this.getFilterValuesDescription(this.filterby.value);
    this.raiseSelected();

  }

  toggleAllSelection() {
    if (this.allSelected.selected) {
      this.searchForm.controls.filterbyformcontrol
        .patchValue([...this.mylist.map(item => item), this.includeAllItem]);
    } else {
      this.searchForm.controls.filterbyformcontrol.patchValue([]);

    }
    this.getFilterValuesDescription(this.filterby.value);
    this.raiseSelected();

  }

  private raiseSelected() {
    let selectedOptions: any[] = this.filterby.selected as Array<any>;
    let selecteditems = [];
    for (let item of selectedOptions) {
      if (item.value.id != this.includeAllItem.id) {
        selecteditems.push(item.value);
      }

    }
    this.onItemSelected.emit(selecteditems);
  }

  selectionDescription:string="";
  getFilterValuesDescription(filterValues: any[]) {
    if (this.allSelected && this.allSelected.selected) {
      this.selectionDescription=this.includeall_text;
      //return this.includeall_text;
    }else     if (filterValues && filterValues.length > 0) {
      this.selectionDescription=filterValues[0].name;
      //return filterValues[0].name;
      if (this.filterby.value?.length > 1){
        let res=  this.filterby.value?.length === 2 ? 'other' : 'others';
        let str="<span>(+" + (this.filterby.value.length - 1) + " " + res +")  </span>";
        this.selectionDescription+=" " + str;
      }
      
    }
    else{
      this.selectionDescription='';
      return;
    }
    
    //return '';
  }



  configureList(listresult: any[]) {

    let list = [];
    if (this.includeall == true) {
      this.includeAllItem = { id: this.includeall_id, name: this.includeall_text, type: "INCLUDEALL" };
    }

    for (let item of listresult) {
      let newItem = { id: item.id, name: item.name, type: "ITEM" };
      list.push(newItem);
    }

    this._mylist = list;

    /*       if (this.selectfirst) {
            if (listresult.length > 0) {
              this.selecteditem = listresult[0].id;
            }
          }else if (this.selecteditem!='-1'){
            this.onFilterChange.emit(this.selecteditem);
            this.notifySelectedItem(this.selecteditem);
          } */
  }

  handleError<T>(err: any) {
    let errbase: ErrorBase = ErrorcontrolService.getListhandleError(err);
  }

}

